import React from 'react';

export default function Warning() {
  return (
    <>
      <h1>You've already made your predications for this week. Come back next week to see how you did!</h1>
    </>
  );
}
